<template>
  <JobsLayout no-heading class="jobs-search-page">
    <template #content>
      <JobOffersSearch />
      <DynamicPagesBlockComponent :dynamic-pages="popularSearches" />
    </template>
  </JobsLayout>
</template>

<script>
  import { createMetaMixin } from "quasar";
  import { MetaHelpers } from "@core/helpers";
  import {
    GETTER_JOBS_GET_CURRENT_METADATA,
    ACTION_JOBS_GET_METADATA_BY_ROUTENAME,
    ACTION_JOBS_GET_POPULAR_SEARCHES,
    GETTER_JOBS_GET_POPULAR_SEARCHES,
  } from "@jobs/store/types";
  import { JOBS_ROUTES } from "@jobs/config";

  import JobsLayout from "@jobs/layouts/Jobs.layout.vue";
  import JobOffersSearch from "@jobs/components/search/JobOffersSearch.component.vue";
  import DynamicPagesBlockComponent from "@jobs/components/dynamic/DynamicPagesBlock.component.vue";

  export default {
    name: "SearchPage",
    components: {
      JobsLayout,
      JobOffersSearch,
      DynamicPagesBlockComponent,
    },
    async preFetch({ store, redirect }) {
      try {
        return Promise.all([
          store.dispatch(ACTION_JOBS_GET_METADATA_BY_ROUTENAME, { routeName: JOBS_ROUTES.public.search.name }),
          store.dispatch(ACTION_JOBS_GET_POPULAR_SEARCHES),
        ]);
      } catch (error) {
        return redirect(`/${JOBS_ROUTES.public.home.path}`, 301);
      }
    },
    mixins: [
      createMetaMixin(function () {
        return MetaHelpers.setAutoMeta({
          title: this.seo.getTitle(),
          description: this.seo.getDescription(),
          type: this.seo.getType(),
          image: this.seo.getImg(),
          canonical: this.seo.getCanonical(),
          noIndex: true,
        });
      }),
    ],
    computed: {
      seo() {
        return this.$store.getters[GETTER_JOBS_GET_CURRENT_METADATA];
      },
      popularSearches() {
        return this.$store.getters[GETTER_JOBS_GET_POPULAR_SEARCHES];
      },
    },
  };
</script>

<style lang="scss">
  .jobs-search-page {
    .jobs-form-sticky {
      top: 0px; // hide title from sticky when we scroll down
    }
  }
</style>
